import React, { useState } from 'react';
import { Modal, Row } from 'antd';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Button, MasterDetailForm, Widget } from '@digital/ui';
import { enviarCartaConviteFornecedor } from '@app/api/sas/ordemCompra';
import { ordemCompraIdState, reloadVendorListState } from '../atoms';
import { Visibility } from '@app/components';

interface Props {
}

const ModalEnvioCartaConvite = ({ }: Props) => {
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);

  const [exibirModal, setExibirModal] = useState(false);

  const onDiscordar = () => {
    setExibirModal(false);
  };

  const onConcordar = () => {
    Modal.confirm({
      title: 'Confirmação Envio de Email',
      content:
        'Você deseja enviar este e-mail?',
      cancelText: 'Não',
      onCancel: () => {
        enviarCartaConviteFornecedor(ordemCompraId, false)
          .then((data: any) => {
            if (data) {
              setReloadVendorList(!reloadVendorList);
            }
          }).finally(() => {
            setExibirModal(false);
          });
      },
      okText: 'Sim',
      onOk: () => {
        enviarCartaConviteFornecedor(ordemCompraId, true)
          .then((data: any) => {
            if (data) {
              setReloadVendorList(!reloadVendorList);
            }
          }).finally(() => {
            setExibirModal(false);
          });
      },
    });
  };

  return (
    <>
      <Button
        type="primary"
        style={{ float: 'right', marginRight: '5px' }}
        onClick={() => {
          setExibirModal(true);
        }}>
        Enviar Carta Convite
      </Button>
      <Visibility visible={exibirModal} >
        <Modal title="Avançar" width="680px" visible={exibirModal} onCancel={() => setExibirModal(false)} footer={null}>
          <MasterDetailForm
            actions={[
              <Button key="discordarBtn" type="link" onClick={() => onDiscordar()}>
                Não
              </Button>,
              <Button key="concordarBtn" type="primary" onClick={() => onConcordar()} >
                Sim
              </Button>
            ]}>
            <Widget>
              <Row>
                <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                  Confirma que todos os documentos necessários foram marcados para serem exibidos para o fornecedor e tem certeza que deseja enviar a carta convite para todos os fornecedores desta Ordem de Compra?
                </p>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>

    </>
  );
};
export default ModalEnvioCartaConvite;
